import React from 'react';
import { Route, Switch } from 'react-router';

import Student from './Student';
import Students from './Students';

export default (
  <Route key="admin-student" path="/admin/student">
    <Switch>
      <Route
        path="/admin/student/"
        exact
        title="Students"
        component={Students}
      />
      <Route
        path="/admin/student/:nodeId"
        exact
        title="Student"
        component={Student}
      />
    </Switch>
  </Route>
);



// WEBPACK FOOTER //
// ./src/modules/admin/student/StudentRoutes.js